import { render, staticRenderFns } from "./item-cpn.vue?vue&type=template&id=1ac2cce9&scoped=true&"
import script from "./item-cpn.vue?vue&type=script&lang=js&"
export * from "./item-cpn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac2cce9",
  null
  
)

export default component.exports